/** Layer 1: fetch countries from backend — no React/TanStack imports. */
import { apiClient } from "@/shared/lib/axios";

export interface Country {
  code: string;
  nameEn: string;
  nameAr: string;
}

export interface CountriesResponse {
  sortedByEn: Country[];
  sortedByAr: Country[];
}

const BASE = "/api/v1/countries";

/** Fetch all countries — returns two pre-sorted lists (EN and AR). */
export async function fetchCountries(): Promise<CountriesResponse> {
  const { data } = await apiClient.get<CountriesResponse>(BASE);
  return data;
}
